enum DragNDropItemTypes {
  DESIGNER = "designer",
  PACK = "packItem",
}

export default DragNDropItemTypes;
